import React from 'react'

const CorporateLogo3: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/corporate_logo3.svg" alt="corporate_logo3"/>
  )
}

export default CorporateLogo3